export default __webpack_public_path__ + "static/home-testimonial-alessandra-515e5f856b28a1b1def4073802dd428d.jpg";